import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AdminPage from "@/pages/AdminPage";
import CancelPage from "@/pages/CancelPage";
import NewsletterConfirmPage from "@/pages/NewsletterConfirmPage";
import NewsletterUnsubscribePage from "@/pages/NewsletterUnsubscribePage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/newsletter/confirm" element={<NewsletterConfirmPage />} />
            <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
